import React, { useState } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import moment from 'moment';
import { motion } from 'framer-motion';
import Logo from '../../img/logo.png';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { green, red, blue } from '@mui/material/colors';
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import SendIcon from '@mui/icons-material/Send';


const SelectP = styled(Select)`
  margin-bottom: 0.1rem;
  width: 250px;
  height: 40px;
  background: none;
  border-radius: 4px;
  border: none;
  font-family: 'Inter', sans-serif;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start; /* Alterado para flex-start */
  padding: 5px;
`;

const Label = styled.label`
  width: 200px;
  color: #CCC6C6;
  margin-bottom: 10px;
  background: none;
  margin-bottom: 0.5rem;
  margin-top: 1rem;
  font-size: 1rem;
  font-family:'Inter', sans-serif;
`;

const Label2 = styled.label`
  color: #CCC6C6;
  background: none;
  margin-top: 1rem;
  font-size: 1rem;
  font-family:'Inter', sans-serif;
`;

const FormWrapper = styled.div`
  background-color: #161616;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  padding: 60px;
  border-radius: 10px 0px 0px 10px;
  align-items: flex-start; /* Adicionado */
  height: auto;
`;

const OutroModel = styled.input`
  margin-bottom: 0.4rem;
  width: 250px;
  height: 60px;
  padding: 10px;
  background: #343333;
  border-radius: 4px;
  border: 1px solid #8D8D8D;
  font-family: 'Inter', sans-serif;
  color: white;
`;

const Input = styled.input`
  margin-bottom: 0.4rem;
  width: 250px;
  height: 60px;
  padding: 10px;
  background: #343333;
  border-radius: 4px;
  border: 1px solid #8D8D8D;
  font-family: 'Inter', sans-serif;
  color: white;
`;

const SelectW = styled.select`
  margin-bottom: 0.4rem;
  width: 250px;
  height: 60px;
  padding: 10px;
  background: #343333;
  border-radius: 4px;
  border: 1px solid #8D8D8D;
  font-family: 'Inter', sans-serif;
  cursor: pointer;

  option{
    font-size: 1.3rem;
  }
`;

const Date = styled.div`
background: none;
`;

const ModelProduct = styled.div`
  margin-top: 1rem;
  margin-bottom: 1rem;
`;

const NameProduto = styled.p`
  width: 250px;
  background: #4491FA;
  font-size: 1.5rem;
  color: white;
  padding: 4px;
  text-align: center;
  font-family: 'Bebas Neue';
  font-weight: 400;

  z-index: -2;
`;

const Nameloja = styled.p`
  width: 250px;
  background: #4491FA;
  font-size: 1.4rem;
  color: white;
  padding: 4px;
  text-align: center;
  font-family: 'Bebas Neue';
  font-weight: 400;
`;

const InputFile = styled.input`
  margin-bottom: 0.4rem;
  width: 250px;
  padding: 10px;
  background: #343333;
  border-radius: 4px;
  border: 1px solid #8D8D8D;
  font-family: 'Inter', sans-serif;
`;

const TextArea = styled.textarea`
  padding: 10px;
  margin-top: 20px;
  width: 250px;
  height: 80px;
  background: #343333;
  border-radius: 4px;
  border: 1px solid #8D8D8D;
  font-family: 'Inter', sans-serif;
`;

const Button = styled.button`
  padding: 15px 60px;
  background-color: #4491FA;
  color: #ffff;
  cursor: pointer;
  border: none;
  font-size: 1.1rem;
  border-radius: 4px;
  margin-top: 1rem;
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  :hover {
    filter: brightness(0.8);
  }
`;

const Info = styled.div`
  border-radius: 0 4px 4px 0;
  padding: 70px;
  width: 100%;
  max-width: 900px;
  background: #232323;
  margin-bottom: 1.2rem;
  align-self: stretch; /* Adicionado */

  @media (max-width: 1000px) {
    display: none;
  }

  p{
    font-size: 1rem;
    font-family: 'inter', sans-serif;
    background: none;
  }

  h1{
    color: #4491FA;
    margin-bottom: 18px;
    background: none;
  }

  img{
    display: block;
    margin: 60px auto;
    padding: 0;
    background: none;
  }
`;

const Info2 = styled.div`
  display: none;
  margin: 1rem;
  padding: 4rem;
  background: #232323;
  border-radius: 2rem;
  margin-bottom: 1rem;

  @media (max-width: 1000px) {
    display: block;
  }
  p{
    font-size: 1rem;
    font-family: 'inter', sans-serif;
    background: none;
  }

  h1{
    color: #4491FA;
    margin-bottom: 1rem;
    background: none;
  }

  img{
    display: block;
    margin: 0px auto;
    padding: 0;
    background: none;
  }
`;

const Title = styled.h1`
  background: none;
  margin-bottom: 1.2rem;
  font-family: 'Bebas Neue', sans-serif;
  background: none;
  font-size: 2.2rem;
`;

const Spanz = styled.span`
  background: transparent;
`;

const Ticketrma = () => {
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [whatsapp, setWhatsapp] = useState('');
  const [loja, setLoja] = useState('');
  const [endereco, setEndereco] = useState('');
  const [cep, setCep] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [files, setFiles] = useState([]);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [foto, setFoto] = useState(null);
  const [video, setVideo] = useState(null);
  const [notaFiscal, setNotaFiscal] = useState(null);
  const [selectedOption, setSelectedOption] = useState('');
  const [showTextInput, setShowTextInput] = useState(false);
  const [additionalInput, setAdditionalInput] = useState('');
  const [dataProduto, setDataProduto] = useState('');
  const [modelo, setModelo] = useState('');
  const [value, setValue] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [selected, setSelected] = useState([]);
  const [otherInputValue, setOtherInputValue] = useState("");
  const [query, setQuery] = useState('idle');
  const timerRef = React.useRef();

  React.useEffect(
    () => () => {
      clearTimeout(timerRef.current);
    },
    [],
  );

  
const buttonSx = {
  ...(query === 'success' ? 
    {
    bgcolor: green[500],
    '&:hover': {
      bgcolor: green[700],
    },
  }
 : query === 'error' ?
 {
  bgcolor: red[500],
  '&:hover': {
    bgcolor: red[700],
  },
}
: {
  bgcolor: '#4491FA',
}
),
};

    const handleWhatsappChange = (e) => {
    const inputValue = e.target.value;
    const formattedValue = inputValue.replace(/[^\d()+-]/g, '');
    setWhatsapp(formattedValue);
  };

  const productsModels = ["RM-COPW-ARGB","RM-COPW-RGB","RM-AC-02-RGB","RM-AC-07-FB","RM-AC-08-RGB","RM-ACZ-Z4-BW","RM-ACZ-Z4-RGB","RM-ACZ-Z5-RGB","RM-ACW-01-ARGB","RM-ACZ-01-BO","RM-ACZ-02-BO","RM-ACZ-03-FB","RM-ACX-01-BB","RM-ACX-04-BG","RM-ACX-03-RGB","RM-ACX-04-RGB","RM-ACX-05-BB","RM-ACX-05-BW","RM-ACX-02-BB","RM-CN-01-RGB","RM-CN-04-BB","RM-CN-05-BB","RM-CN-06-BB","RM-CNV-02-BB","RM-SL-BL","RM-SL-FW","RM-SL-RGB","RM-EX-PV","RM-SL-FR","RM-SL-FB","RM-SL-BW","RM-SL-BR","RM-SL-FG","RM-A1-01-FB","RM-A1-01-BW","RM-A1-01-BG","RM-A1-01-BR","RM-CO-01-BK","RM-CO-02-GR","RM-CO-03-BK","RM-CO-05-BK","RM-CO-06-GR","RM-CO-08-BK","RM-CO-09-BK","RM-CO-10-BK","RM-CO-11-BK","RM-SP-01-RGB","RM-SP-02-BB","RM-SP-03-RGB","RM-SP-04-RGB","RM-SP-05-RGB","RM-SP-06-RGB","RG-UN-01-BLG","RG-UG-01-BLM","RG-UG-01-BLP","RG-UN-01-RDG","RG-UG-01-RDM","RG-UN-01-RDP","RM-CF-01-RS","RM-CF-02-RS","RM-CF-01-DR","RM-CF-02-DR","RM-CF-05-DR","RM-CF-06-DR","RM-CF-03-DR","RM-CF-04-DR","RM-CF-03-AL","RM-CF-04-AL","RM-CF-01-AL","RM-CF-02-AL","RM-CF-03-RS","RM-CF-02-RS","RM-MB-02-12V","RM-MB-02-5V","RM-ARGB-05-5V","RM-FC-04-12V","RM-MB-01-5V","RM-MB-04-5V","RM-MB-01-12V","RM-MB-04-12V","RM-FC-01-5V","RM-FC-03-12V","RM-WN-01","RM-WN-01-BB","RM-WN-01-BW","RM-WN-01-BG","RM-WN-01-BR","RM-WN-02-RGB","RM-AI-02-RGB","RM-BK-01-FB","RM-BK-02-FB","RM-CFI-02-RGB","FNI-02-RGB-5V","RM-LS-05-5V","RM-FC-05-12V","RM-MB-03-5V","RM-FN-00","RM-FN-01-BB","RM-FN-01-BW","RM-FN-01-BG","RM-FN-01-BR","RM-FRM-02-RGB","RM-FC-02-12V","RM-GT-01-FB","RM-FE-02-AT","RM-FE-03-AT","RM-FE-04-AT","RM-PSU-01-BZ-500","RM-PSU-01-BZ-650","RM-PSU-01-GO-850","RM-CA-06-RGB","RM-CA-06-FB","RM-WT-06-FW","RM-WT-06-RGB","RM-WT-06-SF","RM-CA-06X-FB","RM-WT-06X-FW","RM-CA-06XB-ARGB","RM-GA-GGSW-ARGB","RM-GA-OF-FB","RM-GA-GG-FB","RM-GA-GG-FW","RM-GA-GG-PK","RM-GA-GGS-FB","RM-GA-GGS-FW","RM-GA-GGS-PK","RM-GA-GGST-FB","RM-GA-GGST-FW","RM-GA-GGM-FB","RM-GA-GGM-FW","RM-Z01-01-FB","RM-Z02-02-FB","RM-Z03-03-FB","RM-X5-05-FB","RM-Z02-02-RGB","RM-X4-04-FB","RM-HS-OF-01-FB","RM-AU-02-RGB","FN-02-RGB-5V","RM-RGB-05-5V","RM-CF-02-RGB","RM-FN-02-RGB","RM-WA-02-RGB","RM-TO-02-RGB","RM-CF-02-ARGB","RM-CS-02-ARGB","RM-MA-01-ARGB","RM-MA-02-ARGB","RM-D5-16G-4800Z","RM-D5-16G-4800ZW","RM-D5-32G-4800Z","RM-D5-32G-4800ZW","RM-D4-16G-3200Z","RM-D4-8G-3200ZW ","RM-D4-16G-3200ZW","RM-D4-8G-3200Z","RM-D4-8GB-3000D","RM-D4-8GB-3000D WHITE","RM-D4-16GB -3000D","RM-D4-16GB-3000D WHITE","RM-D4-16G-3000D-RGB","RM-D4-8G-2400-RGB","RM-D3-8G-1600VL","RM-D3-8G-1600NL","RM-MG-02-FB","RM-MG-02-FW","RM-MO-01-RGB","RM-MWX-02-FB","RM-MWX-02-FW","RG-MP-04-AK","RG-MP-04-AKR","RG-MP-04-DE","RG-MP-04-ESQ","RG-MP-04-FBK","RG-MP-04-FLT","RG-MP-04-HCK","RG-MP-04-M4A","RG-MP-04-NEO","RG-MP-04-NFR","RG-MP-04-NJA","RG-MP-04-PLA","RG-MP-04-SE","RG-MP-04-SK","RG-MP-04-SNP","RG-MP-04-SPG","RG-MP-04-SR","RG-MP-04-STD","RG-MP-04-ZB","RG-MP-04-ZG","RG-MP-04-ZR","RG-MP-04-ZW","RG-MP-05-AK","RG-MP-05-AKR","RG-MP-05-DE","RG-MP-05-ESQ","RG-MP-05-FBK","RG-MP-05-FLT","RG-MP-05-HCK","RG-MP-05-M4A","RG-MP-05-NEO","RG-MP-05-NFR","RG-MP-05-NJA","RG-MP-05-PLA","RG-MP-05-SE","RG-MP-05-SK","RG-MP-05-SNP","RG-MP-05-SPG","RG-MP-05-SR","RG-MP-05-STD","RG-MP-05-ZB","RG-MP-05-ZG","RG-MP-05-ZR","RG-MP-05-ZW","RG-MP-06-AK","RG-MP-06-AKR","RG-MP-06-DE","RG-MP-06-ESQ","RG-MP-06-FBK","RG-MP-06-FLT","RG-MP-06-HCK","RG-MP-06-M4A","RG-MP-06-NEO","RG-MP-06-NFR","RG-MP-06-NJA","RG-MP-06-PLA","RG-MP-06-SE","RG-MP-06-SK","RG-MP-06-SNP","RG-MP-06-SPG","RG-MP-06-SR","RG-MP-06-STD","RG-MP-06-ZB","RG-MP-06-ZG","RG-MP-06-ZR","RG-MP-06-ZW","RM-MP-07-RGB","RM-TG-01-CLD","RM-TG-01-FRT","RM-PV-GT210-1G","RM-PV-GT220-1G","RM-PV-GT610-2G","RM-PV-GT730-4G","RM-PV-GT1030-4G","RM-PV-GTX750ti-4G","RM-PV-GTX1050ti-4G","RM-PV-GTX1660S-6G","RM-PV-R5220-2G","RM-PV-R7240-4G","RM-PV-R7350-4G","RM-PV-RTX2060-6G","RM-PV-RTX3060-12G","RM-PV-RTX3060TI-8G","RM-PV-RX580-8G","RM-MB-A320-AM4","RM-MB-A520-AM4","RM-MB-H61-1155","RM-MB-H110-1151","RM-SSD-120","RM-SSD-128","RM-SSD-240","RM-SSD-256","RM-SSD-480","RM-SSD-512","RM-SSD-960","RM-SSD-1TB","RM-SSD-2TB","RM-SSD-4TB","RM-SSD-1TB-M2\r","RM-SSD-2TB-M2","RM-M2P-240GB","RM-SC-01-BR","RM-SC-01-BW","RM-SC-01-BB","RM-SC-01-FB","RM-SV-01-AQ","RM-SV-01-SN","RM-SV-01-BK","RM-SV-01-BD","RM-SV-01-HL","RM-SV-02-SA","RM-SV-01-SM","RM-SV-01-OV","RM-SC-02-BB","RM-SC-02-BW","RM-SC-02-FB","RM-SC-02-BR","RM-VN-01-BB","RM-VN-01-BW","RM-VN-01-BR","RM-VN-04-FB","RM-VN-04-BB","RM-VN-04-BW","RM-VN-04-BR","RM-VN-05-FB","RM-VN-05-BB","RM-VN-05-BW","RM-VN-05-BR","RM-AL-01-FB","RM-AL-01-FW","RM-VN-06-BB","RM-VN-06-BW","RM-VN-06-FB","RM-VN-06-BR","RM-SV-01-IC","RM-SV-02-SB","RM-SV-03-BB","RM-SV-03-BR","RM-SV-03-BW","RM-SV-03-FB","RM-SV-04-BB","RM-SV-04-BR","RM-SV-04-BW","RM-SV-04-FB","RM-SV-05-BR","RM-SV-05-BW","RM-TG-01-FB","RM-TG-01-FW","RM-TG-01-BW","RM-TC-01-FB","RM-TG-01-BO","RM-TM-01-FB","RM-TM-02-FB","RM-TMG-06-BW","RM-TMG-06-FB","RM-TMG-06-FW","RM-WCB-01-RGB","RM-WCB-02-RGB","RM-WCB-04-ARGB","RM-WCB-03-RGB","RM-WCZ-01-RGB","RM-WCZ-02-RGB","RM-WCF-04-RGB","RM-WCZ-05-ARGB","RM-WCZ-06-ARGB","RM-WCF-07-ARGB","RM-WAI-01-ARGB","RM-WAI-02-ARGB","RM-WAI-03-ARGB" ,"RM-GA-GGSB-ARGB", "RM-WC-AB-360", "RM-MOG32F1652K-B"]

  const options = productsModels.map(it => {
    return { value: it.trim(), label: it.trim() }
  })

  options.push({ value: "OUTRO", label: "OUTRO" })

  const isOptionSelected = selected.some((option) => option.value === "OUTRO");
    
  const handleChange = (selectedOption) => {
    setSelected(selectedOption);
  };

  const handleOtherInputChange = (event) => {
    setOtherInputValue(event.target.value);
  };

  const enviarTicket = async (nome, email, whatsapp, loja, mensagem, endereco, additionalInput, modelo, cep, dataProduto,  foto, video, notaFiscal) => {
    setButtonDisabled(true);
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    if (query !== 'idle') {
      setQuery('idle');
    }
    
    if (!nome || !email || !whatsapp || !mensagem || !foto || !video || !notaFiscal) {
      setShowErrorMessage(true);
      setTimeout(() => {
        setShowErrorMessage(false);
        setButtonDisabled(false);
      }, 3000);
      timerRef.current = setTimeout(() => {
        setQuery('error');
      }, 2000);
      setButtonDisabled(false);
      return;
    }

    setQuery('progress');

    // Autenticar para coletar o Token Bearer
    const responseBearer = await axios.post('https://api.octadesk.services/login',{
      "username": process.env.REACT_APP_OCTADESK_API_USERNAME,
      "password": process.env.REACT_APP_OCTADESK_API_PASSWORD
    },{
      headers: {
        'Content-Type': 'application/json',
        'subdomain': `${process.env.REACT_APP_OCTADESK_API_SUBDOMAIN}`
      }
    })
    
    if(responseBearer.status != 200){
      setShowErrorMessage(true);
      setTimeout(() => {
        setShowErrorMessage(false);
        setButtonDisabled(false);
      }, 3000);
      timerRef.current = setTimeout(() => {
        setQuery('error');
      }, 2000);
      return;
    }

    const tokenOctadesk = responseBearer.data.token

    const products = []

    for(const opt of selected){
      if(opt.value.trim() === 'OUTRO'){
        const arrayOtherProducts = otherInputValue.trim().split(',')
        for(const other of arrayOtherProducts){
          products.push(other.trim())
        }
      }else{
        products.push(opt.value.trim())
      }
    }
    
  
    // Enviar arquivos para o Zendesk
    const attachments = []
  
    if (foto) {
      const retornoEnvio = await enviarArquivo(tokenOctadesk,foto);
      attachments.push({
    		"url": retornoEnvio.url
      })
    }
    if (video) {
      const retornoEnvio = await enviarArquivo(tokenOctadesk,video);
      attachments.push({
    		"url": retornoEnvio.url
      })
    }
    if (notaFiscal) {
      const retornoEnvio = await enviarArquivo(tokenOctadesk,notaFiscal);
      attachments.push({
    		"url": retornoEnvio.url
      })
    }

    // Enviar ticket para o Zendesk

    // const data = {
    //   ticket: {
    //     subject: 'RMA Rise Mode - ' + nome,
    //     comment: {
    //       body:  mensagem,
    //       uploads: [fotoToken,videoToken,notaFiscalToken]
    //     },
    //     requester: {
    //       name: nome,
    //       email: email,
    //       phone: whatsapp,
    //       details: `${endereco} - ${cep}`
    //     },
    //     brand_id: 16126986193819,
    //     group_id: 16713158837147,
    //     ticket_form_id: 16446130451355,
    //     type: 'problem',
    //     via: {
    //       channel: 'web'
    //     },
    //     tags: ['risemode_brasil','site','rma'],
    //     custom_fields: {
    //       16446069873819: loja === 'outro_loja' ? additionalInput : getSelectedOptionName(),
    //       17232261084315: products,
    //       16716088229275: products.join(', '),
    //       16715192975259: cep,
    //       16715044868507: dataProduto,
    //     }
    //   }
    // }

    //Enviar Ticket para Octadesk

    const data = {
      "requester": {
        "name": nome,
        "email": email
      },
      "summary": 'RMA Rise Mode - ' + nome,
      "numberChannel": 3,
      "idCurrentStatus": "ab59f270-ccb3-4eac-b4e3-5f2d23961dba",
      "idGroupAssigned": "a1ee95f6-ac36-4aac-87da-e176704119ae",
      "tags": [
          "risemode",
          "site",
          "rma"
      ],
      "customField": {
        "data_de_compra": moment(dataProduto).format('DD/MM/YYYY'),
        "loja_que_adquiriu_o_produto": loja === 'OUTRA LOJA' ? additionalInput : getSelectedOptionName(),
        "modelo_do_produto": products[0]
      },
      "idForm": "f1943199-dd83-4ea6-9038-d44405e147ad",
      "comments": {
        "description": {
          "content": mensagem,
          attachments
        }
      }
    }

    // console.log(data)

    await new Promise((resolve) => setTimeout(resolve, 500))

    // Enviar a solicitação para o Zendesk
    try {
      const response = await axios.post('https://api.octadesk.services/tickets/', data, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': 'Bearer '+  tokenOctadesk,
          }
      });

      alert("Enviado com sucesso!");

      setShowSuccessMessage(true);
      setTimeout(() => {
        setShowSuccessMessage(false);
      }, 5000);
      limparCampos();
      timerRef.current = setTimeout(() => {
        setQuery('success');
      }, 2000);

      console.log('Ticket enviado com sucesso:', response.data);
    } catch (error) {
      console.log(error)
      setShowErrorMessage(true);
      setTimeout(() => {
        setShowErrorMessage(false);
        setButtonDisabled(false);
      }, 3000);
      timerRef.current = setTimeout(() => {
        setQuery('error');
      }, 2000);
      return;
    }
    setButtonDisabled(false);
  };  
  
  const enviarArquivo = async (token,arquivo) => {
    try {
        // Enviar a solicitação de upload do anexo
        const response = await axios.post('https://api.octadesk.services/tickets/attachments/upload', {file: arquivo}, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer '+  token,
          }
        });

        console.log('Arquivo enviado com sucesso:', response.data);
        return response.data;
    } catch (error) {
      console.log(error)
      return null;
    }
  };

  const limparCampos = () => {
    setNome('');
    setEmail('');
    setWhatsapp('');
    setLoja('');
    setEndereco('');
    setCep('');
    setModelo('');
    setDataProduto('');
    setMensagem('');
    setFiles([]);
  };

  const handleOptionChange = (e) => {
    const selectedValue = e.target.value;
    setLoja(selectedValue);
    setSelectedOption(selectedValue);
  
    if (selectedValue === 'OUTRA LOJA') {
      setShowTextInput(true);
    } else {
      setShowTextInput(false);
    }
  };

  const getSelectedOptionName = () => {
    switch (selectedOption) {
      case 'RISE USA':
        return 'RISE USA';
      case 'LOJA RISE':
        return 'LOJA RISE';
      case 'KABUM':
        return 'KABUM';
      case 'MODE ON':
        return 'MODE ON';
      default:
        return '';
    }
  };

  const handleCepChange = (event) => {
    const value = event.target.value;
  
    // Remover caracteres não numéricos do valor digitado
    const numericValue = value.replace(/\D/g, '');
  
    // Adicionar o traço após os primeiros 5 dígitos
    let formattedCep = numericValue;
    if (numericValue.length > 5) {
      formattedCep = `${numericValue.slice(0, 5)}-${numericValue.slice(5, 8)}`;
    }
  
    setCep(formattedCep);
  };
  
  const { t } = useTranslation();

  return (
    <motion.div
    initial={{ opacity: 0, scale: 0.5 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ duration: 0.3 }}
  >
      <Info2>
        <h1>{t('welcome.tickerma')}</h1>
        <p>{t('text0.tickerma')}</p>
        <br/>
        <p>{t('text1.tickerma')}</p>
        <br/>
        <p>{t('text2.tickerma')}</p>
        <br/>
        <p>{t('text3.tickerma')}</p>
        <br/>
        <p>{t('text4.tickerma')}</p>
        <br/>
        <p>{t('ticketrma.10')}</p>
        <br/>
        <p>{t('text5.tickerma')}</p>
        <br/>
        <p>{t('text6.tickerma')}</p>
        <br/>
        <p>{t('text7.tickerma')}</p>
        <br/>
        <p>{t('text9.tickerma')}</p>
        <br/>
        <p>{t('ticketrma.11')}</p>
        <br/>
        <p>{t('text8.tickerma')}</p>
        <img src={Logo}/>
      </Info2>
    <Container>
      <FormWrapper>
        <Title alt="Ticket Garantia">{t('footer.ticketrmaT')}</Title>
        <Label alt="Nome">{t('name.contact')}</Label>
        <Input type="text" placeholder="João da Silva" value={nome} onChange={e => setNome(e.target.value)} />
        <Label alt="E-mail">E-Mail</Label>
        <Input type="email" placeholder="rise@email.com" value={email} onChange={e => setEmail(e.target.value)} />
        <Label alt="Celular">{t('cell.contact')}</Label>
        <Input placeholder="(99) 999999-99999" value={whatsapp} onChange={handleWhatsappChange} />
        <Label alt="Nome da Loja">{t('store.tickerma')}</Label>
        <SelectW value={loja} onChange={handleOptionChange}>
          <option value="">{t('select.option')}</option>
          <option value="RISE USA">Rise USA</option>
          <option value="LOJA RISE">Loja Rise</option>
          <option value="KABUM">Kabum</option>
          <option value="MODE ON">Mode on</option>
          <option value="OUTRA LOJA">{t('select.another')}</option>
        </SelectW>

        <Nameloja alt="Nome da Loja  -  Outra loja">{getSelectedOptionName()}</Nameloja>
        {showTextInput && (
          <>
            <Label alt="Outra">{t('select.another')}</Label>
            <Input type="text" placeholder="Store" value={additionalInput} onChange={(e) => setAdditionalInput(e.target.value)} />
          </>
        )}

         <Label alt="Modelo">{t('select.modelo')}</Label>  
         <Date>
            <SelectP
              options={options}
              isMulti
              isSearchable={true}
              value={selected}
              onChange={handleChange}
              theme={(theme) => ({
                ...theme,
                colors: {
                  neutral50: "#fff",
                  primary25: "#4491FA;",
                  primary: "#4491FA;",
                },
              })}
            />
       </Date>

       <ModelProduct>
        {selected && selected.map((option) => (
          <NameProduto key={option.value}>{option.label}</NameProduto>
        ))}
      </ModelProduct>   

       {isOptionSelected && (
        <>
        <Label alt="Outro Modelo">{t('select.another.modelo')}</Label>
        <OutroModel
          type="text"
          placeholder='RM-VN-04-FW'
          value={otherInputValue}
          onChange={handleOtherInputChange}
        />
        </>
      )}

        <Label alt="Endereço">{t('select.endereco')}</Label>
        <Input type="text" placeholder="Endereço" value={endereco} onChange={e => setEndereco(e.target.value)} />

        <Label alt="CEP">CEP</Label>
        <Input
          type="text"
          placeholder="88888-888"
          value={cep}
          maxLength={9} // Define o tamanho máximo do campo como 9 caracteres
          onChange={handleCepChange}
        />
        
        <Label alt="Data">{t('select.data')}</Label>
        <Input type="date" placeholder="YYYY-MM-DD" value={dataProduto} onChange={e => setDataProduto(e.target.value)} />

        <Label2 alt="Contato">{t('message.contact')}</Label2>
        <TextArea value={mensagem} onChange={e => setMensagem(e.target.value)} />  

        <Label alt="Foto Upload">{t('photo.upload')}</Label>
        <InputFile type="file" accept=".jpg" onChange={e => setFoto(e.target.files[0])} />

        <Label alt="Vídeo Upload">{t('video.upload')}</Label>
        <InputFile type="file" accept=".mp4" onChange={e => setVideo(e.target.files[0])} />

        <Label alt="Documento Upload">{t('invoice.upload')}</Label>
        <InputFile type="file" accept=".pdf" onChange={e => setNotaFiscal(e.target.files[0])} />

        {showErrorMessage && <p style={{ color: 'red' }}>{t('alert.campos')}</p>}
        {showSuccessMessage && <p style={{ color: 'green' }}>{t('sucessticket.ticketrma')}</p>}
        <Box sx={{ width: '100%', backgroundColor: 'transparent', marginTop: '3px'}}>
        <LoadingButton
          size='large'
          onClick={() => enviarTicket(nome, email, whatsapp, loja, mensagem, endereco, additionalInput, modelo, cep, dataProduto,  foto, video, notaFiscal)}
          endIcon={<SendIcon />}
          loading={buttonDisabled}
          loadingPosition="end"
          variant="contained"
          TouchRippleProps={{sx: {bgcolor: 'transparent'}}}
        >
          <Spanz>{t('button.contact')}</Spanz>
          </LoadingButton>
      </Box>
      </FormWrapper>
      <Info>
        <h1>{t('welcome.tickerma')}</h1>
        <p>{t('text0.tickerma')}</p>
        <br/>
        <p>{t('text1.tickerma')}</p>
        <br/>
        <p>{t('text2.tickerma')}</p>
        <br/>
        <p>{t('text3.tickerma')}</p>
        <br/>
        <p>{t('text4.tickerma')}</p>
        <br/>
        <p>{t('ticketrma.10')}</p>
        <br/>
        <p>{t('text5.tickerma')}</p>
        <br/>
        <p>{t('text6.tickerma')}</p>
        <br/>
        <p>{t('text7.tickerma')}</p>
        <br/>
        <p>{t('text9.tickerma')}</p>
        <br/>
        <p>{t('ticketrma.11')}</p>
        <br/>
        <p>{t('text8.tickerma')}</p>
        <img src={Logo}/>
      </Info>
    </Container>
  </motion.div>
  );
};

export default Ticketrma;